module.exports = __webpack_public_path__ + "img/practiceinterview.db39f2e7.svg";